import {BaseLink} from "react-router5";
import {useTranslation} from "react-i18next";

export const PostContributeur = ({router,author}) => {
    const { t } = useTranslation();
    // must not be too long or else it will display badly
    const alt = `${author.firstname[0]} ${author.lastname[0]}`.toUpperCase();

    return <BaseLink className={"contributeurContaineur"} router={router} routeParams={{id : author.id}} routeName={'contributor'}>
        <img alt={alt} className={"avatarIcon"} src={author.img} />
        <div className={"author_text_container"}>
            <p className={"author_text"}>{t('Contributeur')}</p>
            <p className={"author_name"}>{author.firstname} {author.lastname}</p>
        </div>
    </BaseLink>
}
